import Logo from "../../components/Logo";
import Campo from "../../components/Campo";
import { Link, useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import { useContext, useEffect, useState } from "react";
import CampoSenha from "../../components/Campo/CampoSenha";
import logar from "../../services/logar";
import { UserContext } from "../../context/UserContext";
import { jwtDecode } from "jwt-decode";

function Login() {
  const navigate = useNavigate();
  const [userLogin, setLogin] = useState("");
  const [userPassword, setPassword] = useState("");
  const [shouldShowError, setShowError] = useState(false);

  const {
    setExp,
    setAuthTime,
    setEmail,
    setName,
    setCnpj,
    setToken,
    setInstId,
    isSessionValid,
  } = useContext(UserContext);
  useEffect(() => {
    if (isSessionValid()) {
      navigate("/conta");
    }
  });
  /**<Link to="/recuperar-senha" className={styles.white_anchor}>
            Recuperar Senha
          </Link> */

  return (
    <section className={styles.background_section}>
      <div className={styles.login_container}>
        <form>
          <Logo shadow={true} />

          <Campo
            title="Login"
            type="text"
            placeholder="Digite seu login (CPF)"
            maxLength={128}
            required={true}
            value={userLogin}
            customValidity="Preencha com o seu Login"
            setter={setLogin}
            hideAsterisk={true}
          ></Campo>
          <CampoSenha
            title="Senha"
            placeholder="Digite sua Senha"
            value={userPassword}
            customValidity="Preencha com a sua Senha"
            setter={setPassword}
            hideAsterisk={true}
          />
          {shouldShowError && (
            <p className={styles.error}>Login ou senha invalidos</p>
          )}
          <input
            type="submit"
            value="Entrar"
            className={styles.submit_button}
            onClick={(e) => {
              e.preventDefault();
              const form = e.currentTarget.form;
              if (form) {
                const login = Array.from(form.elements)[0] as HTMLInputElement;
                const senha = Array.from(form.elements)[1] as HTMLInputElement;

                logar(login.value, senha.value)
                  .then(async (userCredential) => {
                    const { user, token, membro } = userCredential;
                    if (token) {
                      const authTime = Date.now();
                      const expirationTime = token.accessToken.expires_at;
                      setToken(token.plainTextToken || "");
                      setExp(new Date(expirationTime).getTime());
                      setAuthTime(new Date(authTime).getTime());
                      setName(user.name || "");
                      setEmail(user.email || "");
                      setCnpj(membro.instituicao.cnpj);
                      setInstId(membro.instituicao_id);
                      navigate("/conta");
                    }
                  })
                  .catch((err) => {
                    const { code, message } = err;
                    console.log(code, message);
                    setShowError(true);
                    setLogin("");
                    setPassword("");
                  });
              }
            }}
          />

          <hr className="w-80 h-0.5 mb-2 rounded-md border-blue-950 text-lg" />
          <Link to="/cadastro" className={styles.blue_anchor}>
            Criar conta
          </Link>
        </form>
      </div>
    </section>
  );
}
export default Login;
